import {EstateTaxBreakdownReportRow, EstateTaxBreakdownReportRowProps} from "./EstateTaxBreakdownReportRow";
import {formatCurrency} from "../../../utils/format";
import React from "react";
import {TaxType} from "../../../WealthTransfer/components/EstateTaxRunningTotal";
import {v4 as randomUuid} from "uuid";

type EstateTaxRunningTotalsReportProps = {
    estateTaxBreakdownRows: EstateTaxBreakdownReportRowProps[];
    headerTaxWithoutStrategies: number;
    headerTaxWithStrategies: number;
    taxType: TaxType;
    isContinued: boolean;
}

export const EstateTaxRunningTotalsReport = ({
                                                 estateTaxBreakdownRows,
                                                 headerTaxWithoutStrategies,
                                                 headerTaxWithStrategies,
                                                 taxType,
                                                 isContinued
                                             }: EstateTaxRunningTotalsReportProps) => {
    return <div data-testid={`${taxType}-tax-running-totals`} className="running-total">
        <div className={"section-header-background"}>
            <div className={`running-total__section-header-wpo`}>
                <div className="header-column">{isContinued ? `${taxType} (continued)` : taxType}</div>
                <div className="currency">
                    {formatCurrency(headerTaxWithoutStrategies)}
                </div>
                <div className="currency-span-2">
                    {formatCurrency(headerTaxWithStrategies)}
                </div>
            </div>
        </div>

        <div data-testid={`${taxType}-tax-running-totals-breakdown`} className={`running-total__section-wpo`}>
            {estateTaxBreakdownRows.map((estateTaxBreakdownRow) =>
                <div key={`estateTaxBreakdownRow-${randomUuid()}`}>
                    <EstateTaxBreakdownReportRow
                        title={estateTaxBreakdownRow.title}
                        amount={estateTaxBreakdownRow.amount}
                        amountWithStrategies={estateTaxBreakdownRow.amountWithStrategies}
                        description={estateTaxBreakdownRow.description}
                        additionClassNames={estateTaxBreakdownRow.additionClassNames}
                        isStrategyRow={estateTaxBreakdownRow.isStrategyRow}
                        isTaxRateRow={estateTaxBreakdownRow.isTaxRateRow}
                        type={estateTaxBreakdownRow.type}
                        parentRowId={estateTaxBreakdownRow.parentRowId}
                        rowId={estateTaxBreakdownRow.rowId}/>
                </div>
            )}
        </div>
    </div>;
}